if (typeof module === 'object' && module.exports) {
	module.exports = {
		Client: require('./client.js'),
		LegacyClient: require('./legacy_client.js')
	};
}


// WEBPACK FOOTER //
// ./modules/wr_apis/apis/wr_client_api/node_package/src/index.js